export const refundUpdate = () => {
  return process.env.REACT_APP_USER_SERVER + "/change/refund_update";
};

const post_api = {
  refundUpdate,
};

export default post_api;
